import { FAQBlock } from "components/faq-block/faq-block";
import { HeroLeadGenerationSection } from "components/lead-generation-v2/hero-lead-generation-section/hero-lead-generation-section";
import { SubjectTopicsGrid } from "components/subject-topic-grid/subject-topic-grid";
import { TanyaBannerBlock } from "components/tanya-banner-block/tanya-banner-block";
import { TanyaHowTo } from "components/tanya-how-to/tanya-how-to";
import { TanyaSearchBlock } from "components/tanya-search-block/tanya-search-block";
import { useBoolean } from "hooks/use-boolean/use-boolean";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import React from "react";
import { TanyaHomeSEO } from "seo/tanya.seo";
import { useTanyaContext } from "stores/tanya/tanya-context";
import { getLeadSourceFromPath } from "utils/utils";

const ContactMe = dynamic(() => import("components/contact-me/contact-me"));
const LeadGenerationModal = dynamic(
  () =>
    import(
      "components/lead-generation/lead-generation-modal/lead-generation-modal"
    )
);

const Tanya: React.FC = () => {
  const [showLeadGenerationModal, setShowLeadGenerationModal] =
    useBoolean(false);
  const { contactMeForm } = useTanyaContext();
  const router = useRouter();

  const leadSource = getLeadSourceFromPath(router.pathname);
  const { utm_campaign, utm_source, utm_medium, utm_term, utm_content } =
    router.query;

  return (
    <main>
      <TanyaHomeSEO />
      <HeroLeadGenerationSection
        onPriceInfoCTAClick={() => setShowLeadGenerationModal.on()}
        source="Home"
      />
      <TanyaSearchBlock bgTheme="light" isTanyaHome />
      <TanyaHowTo />
      <TanyaBannerBlock />
      <SubjectTopicsGrid />
      <FAQBlock />
      {contactMeForm.show && (
        <ContactMe
          metaData={contactMeForm.metaData}
          onClose={() => contactMeForm.setContactMeFormData({ show: false })}
          leadSource={leadSource}
        />
      )}
      {showLeadGenerationModal && (
        <LeadGenerationModal
          onClose={() => setShowLeadGenerationModal.off()}
          onProceed={() => {
            setShowLeadGenerationModal.off();
            contactMeForm.setContactMeFormData({
              show: true,
              metaData: {
                utm_campaign,
                utm_content,
                utm_medium,
                utm_source,
                utm_term
              }
            });
          }}
        />
      )}
    </main>
  );
};

export default Tanya;
